import React from 'react';
import LinkCard from '../general/LinkCard';
import { currentLanguage } from '../../utils/LanguageUtil';

const language = currentLanguage();

const linkCards = [
  { title: language.questions, link: 'questions' },
  { title: language.resetQuestions, link: 'resetQuestions' },
  { title: language.uploadQuestions, link: 'uploadQuestions' },
  { title: language.removeQuestions, link: 'removeQuestions' },
  { title: language.assignQuestions, link: 'assignQuestions' },
  { title: language.enableTrivia, link: 'enableTrivia' },
];

function AdminQuestions() {
  return (
    <div className="container">
      <div className="title-section">Admin Questions</div>
      <div className="row">
        {linkCards.map((linkCard, index) => (
          <LinkCard key={index} title={linkCard.title} link={linkCard.link} />
        ))}
      </div>
    </div>
  );
}

export default AdminQuestions;
